import AboutUs from "./AboutUs"
import BubblesBg from "./BubblesBg/BubblesBg"

const AboutUsPage = () => {
  return (
    <>
      <AboutUs />
      <BubblesBg variant="variant2"/>
    </>
  )
}

export default AboutUsPage